import ModulPembelajaran from "@/modules/modul_belajar_old/components/ModulBelajar";
import ModulPembelajaranForm from "@/modules/modul_belajar_old/components/Form";

export default [
    {
        path: "/modul-pembelajaran-old",
        name: "ModulPembelajaran",
        component: ModulPembelajaran,
    },
    {
        path: "/modul-pembelajaran-old/form",
        name: "ModulPembelajaranForm",
        component: ModulPembelajaranForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/modul_belajar_old/router/modul_belajar_old.js